import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router/composables'
// @ts-expect-error js file
import store from '@/store'
import { mdiMagnify, mdiPlus } from '@mdi/js'
import { Studio } from '@/modules/Studios/types'
import { StudioApi } from '@/enitites/studio'
import { useDebounceFn } from '@vueuse/core'
import BKInput from '@/components/AppShared/BKInput.vue'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import StudiosGridView from '@/modules/Studios/components/lists/StudiosGridView.vue'
import StudiosMapView from '@/modules/Studios/components/lists/StudiosMapView.vue'
import Bugsnag from '@bugsnag/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StudiosPage',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const studios = ref<Studio[]>([])
const currentUserStudios = ref<Studio[]>([])
const viewType = ref<'grid' | 'map'>('grid')

const getUserDB = computed(() => store.getters.getUserDB)
const createNewStudio = async () => {
  if (!getUserDB.value) {
    await router.push({
      name: 'Signup',
      query: { redirect: route.path },
    })
    return
  }

  const studioId = await StudioApi.createStudio()
  if (studioId) {
    router.push({ name: 'CreateStudio', params: { id: studioId.toString() } })
  }
}

const studioListPayload = ref({
  pageNumber: 0,
  pageSize: 100,
  keyword: '',
})

const fetchStudios = async () => {
  try {
    const response = await StudioApi.fetchStudiosList(studioListPayload.value)
    if (response && response.length) {
      studios.value = response
    }
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error fetching studios',
        payload: studioListPayload.value,
      })
    })
    studios.value = []
  }
}

const fetchUserStudios = async () => {
  try {
    if (getUserDB.value && getUserDB.value.id) {
      const response = await StudioApi.fetchStudiosList({
        ...studioListPayload.value,
        userId: getUserDB.value.id,
      })
      if (response && response.length) {
        currentUserStudios.value = response
      }
    }
  } catch (error) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
      event.addMetadata('studio', {
        context: 'Error fetching user studios',
        userId: getUserDB.value?.id,
      })
    })
    currentUserStudios.value = []
  }
}

const debounceFetchStudios = useDebounceFn(() => {
  studioListPayload.value.pageNumber = 0
  fetchStudios()

  // Load user studios if user is logged in
  if (getUserDB.value) {
    fetchUserStudios()
  }
}, 500)

onMounted(async () => {
  // Load all studios
  fetchStudios()

  // Load user studios if user is logged in
  if (getUserDB.value) {
    await fetchUserStudios()
  }
})

const setViewType = (type: 'grid' | 'map') => {
  viewType.value = type
}

return { __sfc: true,router, route, studios, currentUserStudios, viewType, getUserDB, createNewStudio, studioListPayload, fetchStudios, fetchUserStudios, debounceFetchStudios, setViewType, mdiMagnify, mdiPlus, BKInput, BKSvgIcon, StudiosGridView, StudiosMapView }
}

})